import styled from "styled-components";

export const Overlay = styled.div`
  background: rgba(0, 0, 0, 0.8);
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;

  .close-icon {
    cursor: pointer;
    position: fixed;
    top: 2rem;
    right: 2rem;
    width: 3.125rem;
    height: 3.125rem;
  }

  .left-arrow {
    width: 40px;
    height: 50px;
    position: fixed;
    left: 4rem;
    top: 50%;
    cursor: pointer;
    transform: rotate(180deg) translateX(-50%);
  }

  .right-arrow {
    width: 2.5rem;
    height: 2.5rem;
    position: fixed;
    right: 4rem;
    top: 50%;
    cursor: pointer;
    transform: translateX(-50%);
  }

  .download-button {
    width: 2.5rem;
    height: 2.5rem;
    position: fixed;
    right: 10rem;
    bottom: 6rem;
    background: var(--white);
    cursor: pointer;
  }
`;

export const ModalPictureImage = styled.img`
  height: auto;
  width: auto;
  max-height: 80%;
  max-width: 80%;
  z-index: 9999;
`;

export const SelectedImageInfo = styled.p`
  position: fixed;
  top: 3rem;
  right: 8rem;
  font-weight: bold;
`;

export const CoordinatesWrapper = styled.div`
  position: fixed;
  left: 2rem;
  bottom: 2rem;
  font-weight: bold;
`;

export const CoordinatesContainer = styled.div`
  font-weight: bold;

  display: flex;
  flex-direction: column;
  gap: 0.8rem;

  button {
    padding: 0.3rem;
    border-radius: 0.2rem;
  }
`;
